import BadgeService from '@/bundles/Badge/services/BadgeService';
import { http } from '@/bundles/Http/factory/HttpFactory';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import BadgeToMapper from '@/bundles/Badge/mappers/BadgeToMapper';

function badgeServiceFactory () {
  return new BadgeService({
    transport: http,
    errorMapper: new ErrorMapper(),
    recordMapper: new BadgeToMapper(),
  });
}

export const badgeService = badgeServiceFactory();
